import React from 'react';
import './Gifting_step_1.css';

import MasterButton from '../../../general_components/MasterButton/MasterButton.js';
import Media_selector from '../../../general_components/Pic_selector/Media/Media_selector';
import Greeting_box from '../../../Landing_page/Greeting_box/Greeting_box';

class Gifting_step_1 extends React.Component {
    render () {
        const showAt = this.props.showAtStep != null ? this.props.showAtStep : 1;
        if (this.props.currentStep !== showAt) {
            return null;
        }

        return (
           <div>

                <h2>
                    Add a Greeting{' '}<span className='tiny_text'>(optional)</span>
                </h2>

                {this.props.monthlyGiftFlow ? (
                    <p className='small_text monthly_greeting_helper'>
                        <em>This greeting will be sent with your first monthly gift.</em>
                    </p>
                ) : null}

                <form>
                        <p className='form_label'>What is the occasion? (We’ll offer some greetings!) </p>

                            <select id='occasions'
                                    name='occasion'
                                    className='dropdown_input dropdown_with_arrow'
                                    onChange={this.props.handleChange}
                                    value={this.props.occasion || ''}
                                    placeholder='Birthday / just because / other...' >
                                <option disabled selected hidden value=''>Baby Shower / Graduation / Birthday... </option>
                                <option value='Just because'>       Just because</option>
                                <option value='Baby shower'>        Baby shower</option>
                                <option value='New baby'>           New baby</option>
                                <option value='Holidays'>           Holidays</option>
                                <option value='Birthday'>           Birthday</option>
                                <option value='School Graduation'>  School Graduation</option>
                                <option value='Other'>              Other</option>
                            </select>

                        <Greeting_box   occasion={this.props.occasion}
                                        label={'Greeting'}
                                        handleChange={this.props.handleChange}
                                        greeting={this.props.greeting}
                                        select_greeting={(new_value) => this.props.select_greeting(new_value)}/>
                </form>

                <Media_selector
                    label={'Add a picture or video (max 8MB):'}
                    handlePicChange={this.props.handlePicChange}
                    handleRemoveMedia={this.props.handleRemoveMedia}
                    file={typeof this.props.file === 'string' ? null : this.props.file}/>

                <p className='small_text greeting_skip_explainer'>
                    A short note makes it feel personal. You can send without one.
                </p>

                <MasterButton
                    buttonText={this.props.buttonText}
                    handleButtonClick={this.props.handleButtonClick}
                    notSticky={true}
                />
           </div>
        );
    }
}

export default Gifting_step_1;
